import { Button, Col, Form, Icon, Input, Row } from 'antd';
import { reduxForm } from 'antd-form-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notificacao } from '../master-page/redux/notificacao';
import * as actions from './redux/actions';

export class FormLogin extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    visualizacao: 'LOGIN',
    email: '',
  };

  callbackLogin = action => {
    if (action === 'ACESSO_SISTEMA_LOGIN_SUCCESS') this.setState({ visualizacao: 'SEGUNDOFATOR' });
    else notificacao('error', 'Falha de login');
  };
  callbackLoginSegundoFato = action => {
    if (action === 'ACESSO_SISTEMA_LOGIN_SEGUNDO_FATOR_SUCCESS') {
      this.props.history.push('/');
    } else {
      notificacao('error', 'Código de segurança invalido.');
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.setState({ email: values.username });
      this.props.actions.login({ ...values }, this.callbackLogin);
    });
  };
  handleSubmitSegundoFator = e => {
    e.preventDefault();
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (err) return;

      this.props.actions.loginSegundoFator(
        this.props.acessoSistema.accessTokens.userId,
        values.token,
        this.callbackLoginSegundoFato,
      );
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      acessoSistema,
    } = this.props;
    return (
      <div className="acesso-sistema-form-login">
        {this.state.visualizacao === 'LOGIN' ? (
          <Form onSubmit={this.handleSubmit}>
            <Form.Item>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: 'Campo obrigatório!' }],
              })(
                <Input
                  prefix={<Icon type="mail" style={{ fontSize: 13 }} />}
                  placeholder="Email"
                />,
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Campo obrigatório!' }],
              })(
                <Input
                  prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                  placeholder="Senha"
                  type="password"
                />,
              )}
            </Form.Item>

            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                className="login-form-button"
                icon="login"
                loading={acessoSistema.loginPending}
              >
                {/* <Icon type="login" /> */}
                <span>Acessar</span>
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Form onSubmit={this.handleSubmitSegundoFator}>
            <Row>
              <Col md={20}>
                <h4>
                  Foi enviado um código de 4 digitos para o seu e-mail de login. Informe o código
                  abaixo:
                </h4>
              </Col>
            </Row>

            <Form.Item>
              {getFieldDecorator('token', {
                rules: [{ required: true, message: 'Campo obrigatório!' }],
              })(
                <Input
                  prefix={<Icon type="text" style={{ fontSize: 13 }} />}
                  placeholder="Código de validação"
                />,
              )}
            </Form.Item>

            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                className="login-form-button"
                icon="login"
                loading={acessoSistema.loginSegundoFatorPending}
              >
                {/* <Icon type="login" /> */}
                <span>Validar</span>
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

FormLogin = reduxForm({
  form: 'Login',
})(FormLogin);

FormLogin = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormLogin);

export default FormLogin;



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/FormLogin.js